// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rL5_","field":"styles_field__387pN","fieldCol":"styles_fieldCol__3xOUj","diffCol":"styles_diffCol__QaRdS","diff":"styles_diff__3k04D"};